import React from 'react';
import { ArrowLeftIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import AgencyShareChatButton from '../../AgencyShareChat/AgencyShareChatButton';
import CopyAllButton from '../../CopyAllButton';
import CallSource from '../../Location/CallSource';
import {
  StyledHeader,
  StyledCallerID,
  Tools,
  StyledBackNavigation,
} from './CallPane.styles';

const BPLaptopHeader = ({ onClose, formattedPhone, source }) => {
  return (
    <StyledHeader data-name="event-pane-header">
      <Box align="center" horizontal justify="space-between">
        <Box horizontal flow={20}>
          <StyledBackNavigation onClick={() => onClose()}>
            <ArrowLeftIcon height={16} width={16} />
            <Text ml="3px" size="normal">
              Go Back
            </Text>
          </StyledBackNavigation>
          <Box horizontal flow={5} align="center">
            <StyledCallerID data-name="event-pane-caller-id">
              {formattedPhone}
            </StyledCallerID>
            <CallSource source={source} />
          </Box>
        </Box>
        <Tools align="center" horizontal data-name="event-pane-tools">
          <AgencyShareChatButton />
          <CopyAllButton />
        </Tools>
      </Box>
    </StyledHeader>
  );
};

export default BPLaptopHeader;
